module.exports = __webpack_public_path__ + "media/images/features/wedding-ceremony-cost/wedding_ceremony_cost-about-07aaf0f21bfb7e71347a8df65a49fd9e.jpg";